import { useEffect } from "react";

import { TriangleAlertIcon } from "lucide-react";

import { PrimCallout } from "@/shared-web.ui/prim.callout";
import { semanticColor } from "@/shared-web.ui/styles";
import { cn } from "@/shared-web.ui/util.cn";

import { useCartContext } from "./cart.context";

interface CartErrorProps {
  className?: string;
}
const CartError = (props: CartErrorProps) => {
  const { cartState, dispatchCartAction } = useCartContext();

  const { errors } = cartState;

  useEffect(() => {
    // Set a timeout to hide the error after 5 seconds
    const timer = setTimeout(() => {
      dispatchCartAction({
        type: "clearError",
      });
    }, 5000);

    // Cleanup the timer when the component unmounts
    return () => {
      return clearTimeout(timer);
    };
  }, [errors]);

  if (!errors) {
    return null;
  }

  return (
    <PrimCallout.Root
      color={semanticColor.danger}
      role="alert"
      variant="surface"
      size="2"
      // mb-3 is to align with margin of cart body
      className={cn(`
        mx-2 mb-3 transition-opacity duration-2000
        opacity-100 ease-in-out
      `,
      )}
    >
      <PrimCallout.Icon>
        <TriangleAlertIcon />
      </PrimCallout.Icon>
      <PrimCallout.Text>
        {errors}
      </PrimCallout.Text>
    </PrimCallout.Root>
  );
};

export { CartError };
